export const  defaultformstate = {
    datasaved:false,
    savingdata:false,
    isSeasonSet:true
}


// WEBPACK FOOTER //
// ./src/utils/statedefaultvalues/formstate.js